import { createAction, prepareAutoBatched } from '@reduxjs/toolkit'

import { IAsyncThunkAction, IThunkAction } from 'common/core/interfaces/actions'
import { getPageId } from 'common/core/selectors/appSelectors'
import { chatApi } from 'shared/api/requests/chat'
import { GetLiveChatCountersResponse } from 'shared/api/requests/chat/counters/schemas'
import { createAsyncAction } from 'shared/lib/redux'
import { userNotificationsListener } from 'utils/services/notificationsService'

import { UnreadThreads, UnreadThreadsEvent, UserCounters } from '../models/chatInterfaces'
import { getIsFetchingCounters, getUsersCounters } from '../selectors/countersSelectors'

export const userCountersPatched = createAction(
  'chat/counters/userCountersPatched',
  prepareAutoBatched<UserCounters>(),
)

export const unreadThreadsPatched = createAction(
  'chat/counters/unreadThreadsPatched',
  prepareAutoBatched<UnreadThreads>(),
)

export const updateUserCounters = (data: UserCounters): IThunkAction => {
  return (dispatch, getState) => {
    const pageId = getPageId(getState())
    const eventAccountId = data?.account_id.toString()

    if (eventAccountId && pageId && eventAccountId === pageId) {
      dispatch(userCountersPatched(data))
    }
  }
}

export const updateUnreadThreads = (data: UnreadThreadsEvent): IThunkAction => {
  return (dispatch, getState) => {
    const pageId = getPageId(getState())

    if (data.account_id && String(data.account_id) === String(pageId)) {
      const { unassigned, on_me } = data
      dispatch(unreadThreadsPatched({ unassigned, on_me }))
    }
  }
}

export const fetchThreadCounters = createAsyncAction<GetLiveChatCountersResponse, void>(
  'chat/counters/fetchThreadCounters',
  async () => {
    const response = await chatApi.threads.getLiveChatCounters()
    return response.data
  },
  {
    errorMarkupOptions: { scope: 'livechat', section: 'thread' },
  },
)

export const ensureThreadCounters = (): IAsyncThunkAction => {
  return async (dispatch, getState) => {
    const state = getState()
    if (getIsFetchingCounters(state) || getUsersCounters(state)) return

    return dispatch(fetchThreadCounters())
  }
}

userNotificationsListener.on('account_livechat_counters_updated', (data, dispatch) => {
  dispatch(updateUserCounters(data.model))
})

userNotificationsListener.on('account_livechat_has_unread_thread', (data, dispatch) => {
  dispatch(updateUnreadThreads(data.model))
})
